// extracted by mini-css-extract-plugin
export default {"radio-group":"xmTy","radioGroup":"xmTy","description-item":"h2pc","descriptionItem":"h2pc"};